module.exports = __webpack_public_path__ + "static/img/stop-top.593b2035.png";